import { Component, OnInit, ViewEncapsulation, AfterViewInit, OnDestroy  } from '@angular/core';
import { ConfigurationReaderBase } from '../../../Shared/service/ConfigurationReader';
import { AuthenticationBase } from '../../../Shared/service/Authentication';
import { CommonServiceBase } from '../../../Shared/service/CommonService';
import { User } from '../../../Shared/model/User';
import { ClientSideUtility } from '../../../Shared/service/ClientSideUtility';
import { Subject } from 'rxjs';
import { takeUntil } from '../../../../../node_modules/rxjs/operators';
import { Application } from '../../../Shared/model/Application';

declare let mLayout: any;
@Component({
selector: "app-header-nav",
templateUrl: "./header-nav.component.html",
encapsulation: ViewEncapsulation.None,
})

export class HeaderNavComponent implements OnInit, AfterViewInit, OnDestroy {

    user: User;
    isAuthenticated: boolean;
    title: string;
    private ngUnsubscribe: Subject<boolean> = new Subject<boolean>();
    private ngUnsubscribeUser: Subject<boolean> = new Subject<boolean>();
    private ngUnsubscribeApplication: Subject<boolean> = new Subject<boolean>();
        
    constructor(private configurationReader: ConfigurationReaderBase, private authenticationService: AuthenticationBase,
                private commonService: CommonServiceBase, private clientUtility: ClientSideUtility)  {
        
    }

    ngOnInit(){
        
        if(this.authenticationService.isAuthenticated()){
            this.isAuthenticated = true;
            this.getUserInfo();   
            this.getApplicationTitle();         
        }
        else
        {
            this.authenticationService.isAuthenticationCompleted()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe( (r)=>{ 
                this.isAuthenticated = true;
                this.getUserInfo();      
                this.getApplicationTitle();         
            });
        }
    }

    ngAfterViewInit()  {
        mLayout.initHeader();
    }

    getUserInfo() :void{

        this.commonService.getCurrentUserInfo()
        .pipe(takeUntil(this.ngUnsubscribeUser))
        .subscribe((r) =>{
            this.user = r;            
        },
        (error:any)=> {
            this.clientUtility.showAlertError("Error", error);
        });
    }

    getApplicationTitle(): void{
        this.commonService.getUserApplication()
        .pipe(takeUntil(this.ngUnsubscribeApplication))
        .subscribe(
            data=> {
                if(data!=null){
                    this.title = data.title;
                }                
            }
        )
    }

    logout():void{
        this.authenticationService.logout();
    }

    ngOnDestroy(): void {        
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
        this.ngUnsubscribeUser.next();
        this.ngUnsubscribeUser.complete();
        this.ngUnsubscribeApplication.next();
        this.ngUnsubscribeApplication.complete();
      }
}


// WEBPACK FOOTER //
// C:/TeamCity/buildAgent/work/4b34a5ca2bd08993/UI/rp/src/app/theme/layouts/header-nav/header-nav.component.ts